export default "__VITE_ASSET__DrXCZdgQ__"